import { Directive, ElementRef, input, effect } from '@angular/core';

@Directive({
  selector: '[indeterminate]',
  standalone: false
})
export class IndeterminateDirective {
  public indeterminate = input<boolean>(false);

  constructor(private el: ElementRef<HTMLInputElement>) {
    effect(() => {
      this.el.nativeElement.indeterminate = this.indeterminate();
    });
  }
}